import SiafLiteApiRepository from "../../external/siafLiteApi";

class MaoObraService {
  constructor() {
    this.urlBase = "/estoque/mao-obra";
    this.urlBaseEvent = `/event${this.urlBase}`;
  }

  getAll(filter) {
    return new SiafLiteApiRepository(this.urlBaseEvent).get(filter);
  }

  upsert(body) {
    return new SiafLiteApiRepository(`${this.urlBaseEvent}/upsert`).post(body);
  }
}

export default MaoObraService;
